export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "process_line_exec_attr": {
            "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valor"])},
            "unit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unidad"])},
            "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Observaciones"])},
            "process_line_step_attr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atributo"])}
          }
        }
      }
    }
  })
}